var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "2199pt",
    height: "2500pt",
    viewBox: "0 0 2199 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,2500)",
    d: "M0 2500H2199V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,2500)",
    d: "M446.514 618.328H1021.18V1938.04H446.514Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_2"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,2500)",
    d: "M446.514 618.328H1021.18V1938.04H446.514Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_3"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,2500)",
    d: "M441.867 612.907H1025.05V1942.68H441.867Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_4"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,2500)",
    d: "M441.867 612.907H1025.05V1942.68H441.867Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "layer_1",
    "data-name": "svg4525"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1025.0474,556.54397)",
    d: "M0 0H-197.491L-199.814-1040.121-583.18-935.567-582.406-1173.331 0-1330.55ZM734.978-1483.121 889.098 254.802H75.899L82.094-1662.025ZM-734.203-1593.871-918.528 435.255 1067.228 434.481 884.452-1592.322 72.801-1821.567Z",
    fill: "#ccb43f"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.985992
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_2)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,959.9917,1867.7315)",
    d: "M0 0C-25.558 7.745-151.797 41.821-280.36 76.673L-513.478 139.405V256.352C-513.478 370.974-513.478 373.298-501.86 369.425-495.665 367.102-410.472 343.867-312.888 316.761L-135.533 267.969-133.984 786.868-132.436 1305.767H61.184V645.913C61.184 121.593 59.634-13.94 54.213-13.94 50.341-13.166 25.558-6.97 0 0",
    fill: "#e4e5e4"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.985992
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_3)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9216
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_4)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,442.6416,1729.875)",
    d: "M0 0-.774 237.765C-.774 237.765 243.96 168.836 382.591 133.21L384.915 1172.557H582.406V-157.219Z",
    fill: "#e4e5e4"
  })))))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1718.2031,1747.6875)",
    d: "M0 0 53.439 649.785-341.544 605.64V952.605L79.771 954.154 96.81 1191.144-539.035 1188.045-530.516 325.279-146.376 391.109-151.797 199.04-539.035 96.035-535.162-139.406ZM-617.257 1446.721H195.942L41.822-291.203-617.257-470.107Z",
    fill: "#fad74b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsLogo);
export default __webpack_public_path__ + "static/media/js-logo.a6b7d1da42d35a8075dc40d97b2af3fb.svg";
export { ForwardRef as ReactComponent };